// extracted by mini-css-extract-plugin
module.exports = {"container":"RenderError__container___u50uB","error":"RenderError__error___XYtNl"};